{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome proširenje nije instalirano.",
      "CTA": "Instaliraj proširenje"
    },
    "STATUS": {
      "OFFLINE": "Telefon nije povezan",
      "IN_OTHER_TAB": "Telefon povezan u drugoj kartici",
      "CONNECTING": "Povezivanje...",
      "DISCONNECTING": "Prekidanje veze...",
      "ONLINE": "Telefon povezan",
      "DIALING": "Biranje",
      "TRANSFERRING": "Prebacivanje...",
      "CONSULTING": "Razgovor s agentom",
      "CALLER_ON_HOLD": "Pozivatelj je na čekanju",
      "BUSY": "Zauzeto",
      "DND": "DND",
      "UNAVAILABLE": "Nedostupno",
      "REJECTED": "Poziv odbijen",
      "CALL_FAILED": "Poziv nije uspio"
    },
    "QUEUES": {
      "MORE": "Ostali redovi čekanja"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Povijest"
    },
    "HISTORY": {
      "OPEN": "Otvoren",
      "RECENT": "Nedavni",
      "MISSED": "Propušteni",
      "LOADING": "Učitavanje poziva...",
      "EMPTY": "Nema poziva",
      "ERROR": "Učitavanje poziva nije uspjelo",
      "CALL": "Nazovi natrag",
      "CALL_STATUS": {
        "BUTTON": "Postavi status poziva",
        "TITLE": "Status poziva",
        "SEARCH_PLACEHOLDER": "Pretraži statuse...",
        "LOADING": "Učitavanje statusa...",
        "NO_OPTIONS": "Nijedan status poziva nije postavljen",
        "NO_MATCH": "Nijedan status nije pronađen",
        "OPTIONS_ERROR": "Učitavanje statusa nije uspjelo",
        "RETRY": "Pokušaj ponovno",
        "CONFIRM_QUESTION": "Jeste li sigurni da želite postaviti status „{status}” i riješiti razgovor?",
        "CONFIRM": "Potvrdi",
        "BACK": "Natrag",
        "CANCEL": "Odustani",
        "SAVING": "Spremanje...",
        "SAVE_ERROR": "Spremanje statusa nije uspjelo",
        "RESOLVE_ERROR": "Status je spremljen, ali razgovor nije bilo moguće riješiti"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Broj telefona, npr. +421903000000",
      "BODY_PLACEHOLDER": "Napišite poruku...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Pošalji SMS",
      "SENDING": "Šaljem...",
      "SENT": "SMS poslan",
      "LOADING": "Učitavanje SMS sandučića...",
      "NO_INBOX": "Ovaj račun nema SMS sandučić pa se SMS ne može poslati.",
      "INVALID_NUMBER": "Unesite broj u međunarodnom formatu, uključujući početni +.",
      "ERROR": "SMS nije poslan. Pokušajte ponovno."
    },
    "ACTIONS": {
      "CONNECT": "Poveži",
      "GO_TO_TAB": "Idi na tu karticu",
      "DISCONNECT": "Prekini vezu",
      "ANSWER": "Prihvati",
      "HANGUP": "Prekini",
      "HOLD": "Na čekanje",
      "MUTE": "Isključi mikrofon",
      "SILENCE": "Utišaj zvuk",
      "TRANSFER": "Prebaci",
      "COMPLETE_TRANSFER": "Dovrši prebacivanje",
      "RETURN_TO_CALLER": "Natrag na pozivatelja",
      "CANCEL_TRANSFER": "Otkaži prebacivanje",
      "DIALPAD": "Prikaži tipkovnicu",
      "OPEN_CONVERSATION": "Otvori razgovor"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Dolazni poziv",
      "INCOMING_CALL_FROM": "Dolazni poziv od {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Dolazni poziv s broja {number}",
      "ANSWER": "Prihvati",
      "DECLINE": "Odbij"
    },
    "TRANSFER": {
      "TITLE": "Prebaci poziv",
      "PLACEHOLDER": "Unesite broj za prebacivanje...",
      "SEARCH_PLACEHOLDER": "Pretraži agente...",
      "TARGET_PLACEHOLDER": "Odabrani cilj prebacivanja",
      "CONFIRM": "Prebaci",
      "MODE_DIRECT": "Prebaci odmah",
      "MODE_CONSULT": "Prvo nazovi agenta",
      "CANCEL": "Odustani"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Jeste li sigurni da želite ići na pauzu za sve redove čekanja?",
      "CONFIRM_READY": "Jeste li sigurni da se želite vratiti u status spreman za sve redove čekanja?",
      "CONFIRM_BREAK_QUEUE": "Jeste li sigurni da se želite odjaviti iz reda {queue}?",
      "CONFIRM_READY_QUEUE": "Jeste li sigurni da se želite prijaviti u red {queue}?",
      "LOGIN_TO_QUEUE": "Prijava",
      "LOGOUT_FROM_QUEUE": "Odjava",
      "LOGIN_TO_ALL_QUEUES": "Prijava u sve redove",
      "LOGOUT_FROM_ALL_QUEUES": "Odjava iz svih redova",
      "OPTION_LOGOUT": "Odjava",
      "OPTION_BREAK": "Pauza",
      "OPTION_LUNCH": "Ručak",
      "OPTION_AWAY": "Odsutan",
      "OPTION_DO_NOT_DISTURB": "Ne ometaj",
      "OPTION_BUSINESS_TRIP": "Poslovni put",
      "CONFIRM": "Potvrdi",
      "CANCEL": "Odustani"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Nema veze s telefonskim sustavom",
      "MESSAGE": "Čini se da vaša internetska veza ne radi. Provjerite je i pokušajte ponovno.",
      "CREDENTIALS_TITLE": "Telefonski sustav je odbio vaše vjerodajnice",
      "CREDENTIALS_MESSAGE": "Telefonski sustav je odbio korisničko ime ili lozinku spremljenu u vašem profilu. Provjerite ih u postavkama profila ili se obratite administratoru.",
      "CONFIGURATION_TITLE": "Postavke telefona nisu ispravne",
      "CONFIGURATION_MESSAGE": "SIP korisničko ime ili adresa poslužitelja nisu u ispravnom formatu, pa se telefon ne može povezati. Ispravite to u postavkama profila.",
      "NETWORK_SHORT": "Povezivanje nije uspjelo",
      "CREDENTIALS_SHORT": "Vjerodajnice odbijene",
      "CONFIGURATION_SHORT": "Neispravne postavke telefona",
      "RETRY": "Pokušaj ponovno",
      "DISMISS": "Odustani"
    },
    "CONNECTION_QUALITY": "Kvaliteta veze",
    "CONNECTION_QUALITY_EXCELLENT": "Izvrsna",
    "CONNECTION_QUALITY_GOOD": "Dobra",
    "CONNECTION_QUALITY_FAIR": "Zadovoljavajuća",
    "CONNECTION_QUALITY_POOR": "Loša",
    "CONNECTION_QUALITY_DISCONNECTED": "Nije povezano"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Biranje broja {number}… Možete zatvoriti ovu karticu.",
    "NO_NUMBER": "Broj nije naveden. Koristite ?number=+385..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Unesite telefonski broj...",
    "ACTIONS": {
      "DIAL": "Nazovi broj",
      "DIAL_FROM": "Odaberite broj s kojeg zovete"
    },
    "DIAL_FROM": {
      "TITLE": "Poziv s broja sandučića"
    },
    "VALIDATION": {
      "REQUIRED": "Telefonski broj je obavezan",
      "INVALID_FORMAT": "Neispravan format telefonskog broja"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Postavke i testiranje zvuka",
    "SELECT_DEVICE": "Odaberite uređaj...",
    "SYSTEM_DEFAULT": "Zadano u sustavu",
    "SAVED": "Spremljeno",
    "DISCONNECTED_SUFFIX": "nije povezano",
    "DEVICE_DISCONNECTED": "Odabrani uređaj nije povezan. Pozivi koriste zadani uređaj sustava dok se ne vrati.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Testiraj mikrofon",
      "STOP_TEST": "Zaustavi test",
      "LEVEL": "Razina:",
      "VERDICT": {
        "LISTENING": "Recite nešto u mikrofon…",
        "SILENT": "Ne čuje vas se. Provjerite je li mikrofon uključen i je li odabran pravi.",
        "LOW": "Čuje vas se samo tiho. Odaberite drugi mikrofon ili prilagodite ulaznu glasnoću u postavkama sustava.",
        "GOOD": "Dobar zvuk — dobro vas se čuje."
      }
    },
    "SPEAKER": {
      "TITLE": "Zvučnik",
      "TEST": "Testiraj zvučnik",
      "TESTING": "Testiranje...",
      "VOLUME": "Glasnoća:",
      "USING_DEFAULT": "Odabrani izlaz nije dostupan — reproducirano na zadanom uređaju sustava."
    },
    "DONE": "Gotovo",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Pogreška pri pristupu mikrofonu. Provjerite dozvole.",
      "MICROPHONE_PERMISSION_DENIED": "Pristup mikrofonu je blokiran. Dopustite ga u postavkama web-mjesta u pregledniku kako biste mogli koristiti telefon.",
      "MICROPHONE_SILENT": "Vaš mikrofon ne hvata nikakav zvuk. Provjerite postavke zvuka.",
      "EXTENSION_REQUIRED": "Telefonsko proširenje nije otkriveno. Instalirajte ga ili omogućite kako biste koristili mikrofon.",
      "SPEAKER_TEST": "Pogreška pri testiranju izlaza zvučnika."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Nedostupan",
    "ONLINE": "Dostupan",
    "BUSY": "Zauzet"
  },
  "QUEUE_STATUS": {
    "READY": "Spreman",
    "NOT_READY": "Ne prima pozive",
    "WRAP_UP": "Završavanje",
    "BREAK": "Pauza",
    "LUNCH": "Ručak",
    "AWAY": "Odsutan",
    "DO_NOT_DISTURB": "Ne ometaj",
    "BUSINESS_TRIP": "Poslovni put",
    "OTHER_CALL": "Drugi poziv",
    "QUEUE_CALL": "Poziv iz reda čekanja",
    "OFFLINE": "Nedostupan",
    "ONLINE": "Dostupan",
    "NO_ACCESS": "Nema telefona",
    "PARTIALLY_READY": "Djelomično spreman",
    "MIXED": "Mješovito",
    "CHAT_ONLINE": "Dostupan (chat)",
    "CHAT_BUSY": "Zauzet (chat)",
    "CHAT_OFFLINE": "Nedostupan (chat)"
  }
}
